import Const from 'const';
import {LateSwapUsedPlayersInterface} from 'components/organisms/late-swap/late-swap-interfaces';

class LateSwapUsedPlayers implements LateSwapUsedPlayersInterface {
    constructor(public readonly players: object[] = []) {}
    hasPlayers(): boolean {
        return this.players.length > 0;
    }
    getAllAsArr(): object[] {
        return [...this.players];
    }
}

const lateSwapUsedPlayers = new LateSwapUsedPlayers();

export default function (state = lateSwapUsedPlayers, action) {
    switch (action.type) {
        case Const.LATESWAP_SET_LINEUPS_USED_PLAYERS:
            return new LateSwapUsedPlayers(action.players);

        case Const.FILTER_BY_SLATE:
            return new LateSwapUsedPlayers();

        default:
            return state;
    }
}
